<template>
  <div class="position-relative font-size-12-400 font-grey d-flex align-center card-container justify-space-between">
    <div>
      {{ title }}
    </div>

    <slot></slot>
  </div>
</template>

<script setup lang="ts">
import {defineProps} from 'vue'

defineProps({
  title: String
})
</script>

<style lang="scss" scoped>
.card-container {
  height: 40px;
  gap: 4px;
}
</style>